/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import BookmarkBorder from '@material-ui/icons/BookmarkBorder';

import UsuarioAdministrar from 'conten/usuarios/UsuarioAdministrar';

import ZonaAdministrar from 'conten/zonas/ZonaAdministrar';

import PromotorZonaAdministrar from 'conten/promotorZonas/PromotorZonaAdministrar';

import Principal from 'conten/principal/Principal';

import Mapa from 'conten/mapa/Mapa';

import CuentaAdministrar from 'conten/cuentas/CuentaAdministrar';

import MesaDeAyuda from 'conten/mesaDeAyuda/MesaDeAyuda';

import InformeVehiculo from 'conten/informes/InformeVehiculo';

import { ID_PERFIL } from 'config/general/Configuracion';

import SuscripcionPlacaAdministrar from 'conten/mensualidades/SuscripcionPlaca/SuscripcionPlacaAdministrar';
import PlanesAdministrar from 'conten/mensualidades/planes/PlanesAdministrar';
import PlacasAdministrar from 'conten/mensualidades/Placas/PlacasAdministrar';
import PlacasListar from 'conten/mensualidades/Placas/PlacasListar';

export const routes = () => {
  return filterByProfile(getRutasPermisos());
};

const filterByProfile = (content) => {
  var filterContent = [];
  content.forEach((element) => {
    if (
      element.permition.indexOf(ALL) > -1 ||
      element.permition.indexOf(localStorage[ID_PERFIL]) > -1
    ) {
      if (element.views !== undefined) {
        element.views = filterByProfile(element.views);
      }
      filterContent.push(element);
    }
  });
  return filterContent;
};

const emojiIcon = (emoji) => () => (
  <div
    style={{
      fontSize: '18px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 24,
      height: 24,
      lineHeight: 1,
    }}
  >
    {emoji}
  </div>
);

const ALL = '*',
  CIUDADANO = '107';

export const getRutasPermisos = () => {
  return [
    {
      path: '/principal',
      name: 'Inicio',
      icon: emojiIcon('🏠'),
      component: Principal,
      layout: '/admin',
      permition: [CIUDADANO],
    },
    {
      path: '/mapa',
      name: 'Tráfico en tiempo real',
      icon: emojiIcon('🗺️'),
      component: Mapa,
      layout: '/admin',
      permition: [CIUDADANO],
    },
    {
      path: '/placas',
      name: 'Mis vehículos',
      icon: emojiIcon('🚗'),
      component: PlacasListar,
      layout: '/admin',
      permition: [CIUDADANO],
    },
    {
      collapse: true,
      name: 'Movimientos',
      icon: emojiIcon('📋'),
      layout: '/admin',
      permition: [CIUDADANO],
      views: [
        {
          path: '/informe-vehiculo',
          name: 'Historial parqueos',
          icon: emojiIcon('🕒'),
          component: InformeVehiculo,
          layout: '/admin',
          permition: [CIUDADANO],
        },
        {
          path: 'https://sistemaszer365.com:8443/consulta-placas-zer/',
          name: 'Estado de cuenta vehicular',
          icon: emojiIcon('💰'),
          external: true,
          layout: '/admin',
          permition: [CIUDADANO],
        },
      ]
    },
    {
      path: 'https://sistemaszer365.com/auth/terminos-y-condiciones/210504082820861533',
      name: 'Términos y condiciones',
      icon: emojiIcon('📜'),
      external: true,
      layout: '/admin',
      permition: [CIUDADANO],
    },
    {
      path: '/mesa-de-ayuda',
      name: 'Tu voz cuenta',
      icon: emojiIcon('💬'),
      component: MesaDeAyuda,
      layout: '/admin',
      permition: [
        CIUDADANO
      ],
    },
    //Redirects
    {
      path: '/administrar-cuenta',
      name: 'Nueva cuenta',
      icon: BookmarkBorder,
      component: CuentaAdministrar,
      layout: '/admin',
      redirect: true,
      permition: [CIUDADANO],
    },
    {
      path: '/administrar-usuario',
      name: 'Nuevo usuario',
      icon: BookmarkBorder,
      component: UsuarioAdministrar,
      layout: '/admin',
      redirect: true,
      permition: [CIUDADANO],
    },
    {
      path: '/administrar-zona',
      name: 'Nueva zona',
      icon: BookmarkBorder,
      component: ZonaAdministrar,
      layout: '/admin',
      redirect: true,
      permition: [CIUDADANO],
    },
    {
      path: '/administrar-promotor-zona',
      name: 'Nuevo promotor zona',
      icon: BookmarkBorder,
      component: PromotorZonaAdministrar,
      layout: '/admin',
      redirect: true,
      permition: [CIUDADANO],
    },
    {
      path: '/administrar-suscripcion-placa',
      name: 'Nueva sucripcion Placa',
      icon: BookmarkBorder,
      component: SuscripcionPlacaAdministrar,
      layout: '/admin',
      redirect: true,
      permition: [CIUDADANO],
    },
    {
      path: '/administrar-plan',
      name: 'Nuevo plan',
      icon: BookmarkBorder,
      component: PlanesAdministrar,
      layout: '/admin',
      redirect: true,
      permition: [CIUDADANO],
    },


    {
      path: '/administrar-placas',
      name: 'Nuevo vehículo',
      icon: BookmarkBorder,
      component: PlacasAdministrar,
      layout: '/admin',
      redirect: true,
      permition: [CIUDADANO],
    },
    // {
    //   collapse: true,
    //   name: 'Mensualidades',
    //   icon: DateRange,
    //   state: 'mensualidadesCollapse',
    //   permition: [CIUDADANO],
    //   views: [
    //     {
    //       path: '/placas',
    //       name: 'Tus vehículos',
    //       mini: 'V',
    //       component: PlacasListar,
    //       layout: '/admin',
    //       permition: [CIUDADANO],
    //     },
    //     {
    //       path: '/planes',
    //       name: 'Planes',
    //       mini: 'P',
    //       component: PlanesListar,
    //       layout: '/admin',
    //       permition: [CIUDADANO],
    //     },
    //     {
    //       path: '/suscripcion-placa',
    //       name: 'Suscripcion Placa',
    //       mini: 'SP',
    //       component: SuscripcionPlacaListar,
    //       layout: '/admin',
    //       permition: [CIUDADANO],
    //     },
    //   ],
    // },
  ];
};
